import React, { useCallback, useEffect, useMemo, useState } from "react";
import Propinsi from "../../../../utilities/Propinsi";
import KotaKab from "../../../../utilities/KotaKab";
import StatusPrimer from "../../../../utilities/primer/StatusPrimer";
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap";
import { FaBars, FaMinus, FaPlus } from "react-icons/fa";
import PbUmkuService from "../../../../services/pbumku/PbumkuService";
import Card from "../../../../components/Card";
import DataTable from "react-data-table-component";
import ExpandableComponentPrimer from "../../base/expand/ExpandableComponentPrimer";
import OffCanvasLog from "../../base/offcanvas/OffCanvasLog";

const TerbitSkp = () => {
    const columns = [
        {
            name: 'Permohonan',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12">
                            <b>Nomor Aju :</b>
                        </div>
                        <div className="col-12">
                            {row['nomorAju']}
                        </div>
                        <div className="col-12">
                            <b>Nomor Permohonan :</b>
                        </div>
                        <div className="col-12">
                            {row['idIzin']}
                        </div>
                        <div className="col-12">
                            <b>Tanggal Permohonan :</b>
                        </div>
                        <div className="col-12">
                            {row['tglPermohonan']}
                        </div>
                    </div>
                </>
            )
        },
        {
            name: 'Perusahaan',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12">
                            <b>NIB :</b>
                        </div>
                        <div className="col-12">
                            {row['nib']}
                        </div>
                        <div className="col-12">
                            <b>Nama Perusahaan :</b>
                        </div>
                        <div className="col-12">
                            {row['namaPerseroan']}
                        </div>
                    </div>
                </>
            ),
            grow: 0.75
        },
        {
            name: 'No Kegiatan Usaha',
            cell: row => row['nomorProyek'],
        },
        {
            name: 'Usaha',
            cell: row => row['uraianUsaha'],
            grow: 0.75
        },
        {
            name: 'Propinsi',
            cell: row => <Propinsi id={row['kodePropinsi']} />,
            grow: 0.5
        },
        {
            name: 'Kota/Kab',
            cell: row => <KotaKab id={row['kodeKota']} />,
            grow: 0.5
        },
        {
            name: 'Asal Data',
            cell: row => row['asalData'] === 'O' ? 'OSS' : 'Manual',
            grow: 0.4
        },
        {
            name: 'Status Permohonan',
            cell: row => <StatusPrimer kodeStatus={row['kodeStatus']} />,
            grow: 0.75
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >History Permohonan</Tooltip>}>
                            <Button size="sm" variant="secondary" onClick={() => ViewLogStatus(row)}>
                                <FaBars /> History
                            </Button>
                        </OverlayTrigger>{' '}
                    </div>
                </div>
            ),
            grow: 0.5
        }
    ]

    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getDataOss = useCallback(async (page, size) => {
        setLoading(true)
        try {
            let resList
            if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
                resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', null, null, null, page, size, localStorage.getItem("kdUnit"))
            } else {
                resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', null, null, null, page, size, null)
            }
            setListData(resList.data.data)
            setTotalData(resList.data.totalData)
        } catch (error) {
            setListData(null)
        }
        setLoading(false)
    }, [pbumkuService])

    useEffect(() => {
        getDataOss(0, 10)
    }, [getDataOss])

    const handleChangePage = (page) => {
        getDataOss(page - 1, size)
    }

    const handlePerRowsChange = async (size, page) => {
        let resList
        if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
            resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', valueSearchNomorAju, valueSearchNib, null, page, size, localStorage.getItem("kdUnit"))
        } else {
            resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', valueSearchNomorAju, valueSearchNib, null, page, size, null)
        }
        setListData(resList.data.data)
        setSize(size)
    }

    const reloadList = async (nomorAju) => {
        setLoading(true)
        try {
            let resList
            if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
                resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', nomorAju, null, null, 0, size, localStorage.getItem("kdUnit"))
            } else {
                resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', nomorAju, null, null, 0, size, null)
            }
            setListData(resList.data.data)
            setTotalData(resList.data.totalData)
        } catch (error) {
            setListData(null)
        }
        setLoading(false)
    }

    const [rowData, setRowData] = useState(null)
    const [showLog, setShowLog] = useState(false)
    const handleCloseLog = () => setShowLog(false)

    const ViewLogStatus = (rowdata) => {
        setRowData(rowdata)
        setShowLog(true)
    }

    const [valueSearchNib, setValueSearchNib] = useState(null)
    const [valueSearchNomorAju, setValueSearchNomorAju] = useState(null)

    const onChangeSearchNib = e => {
        setValueSearchNib(e.target.value)
    }
    const onChangeSearchNomorAju = e => {
        setValueSearchNomorAju(e.target.value)
    }

    const handleClickCari = async () => {
        setLoading(true)
        try {
            let resList
            if (localStorage.getItem("role") === '2' || localStorage.getItem("role") === '7') {
                resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', valueSearchNomorAju, valueSearchNib, null, 0, size, localStorage.getItem("kdUnit"))
            } else {
                resList = await pbumkuService.listUmkuHeaderTerbit('032000000023', valueSearchNomorAju, valueSearchNib, null, 0, size, null)
            }
            setListData(resList.data.data)
            setTotalData(resList.data.totalData)
        } catch (error) {
            setListData(null)
        }
        setLoading(false)
    }

    const handleClickReset = () => {
        setValueSearchNib(null)
        setValueSearchNomorAju(null)
        getDataOss(0, 10)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">NIB</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="NIB" className="form-control-sm" value={valueSearchNib} onChange={onChangeSearchNib} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor Aju</Form.Label>
                                            <Col sm="9">
                                                <Form.Control type="searchNib" placeholder="Nomor Aju" className="form-control-sm" value={valueSearchNomorAju} onChange={onChangeSearchNomorAju} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar SKP Terbit Sertifikat / Lampiran Teknis </h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                    expandableRowsComponent={({ data }) => <ExpandableComponentPrimer data={data} reloadList={reloadList} jenisIzin='SKP' />}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <OffCanvasLog showLog={showLog} handleCloseLog={handleCloseLog} dataPrimer={rowData} />
        </>
    )
}

export default TerbitSkp